module.exports = __webpack_public_path__ + "static/stone-style-3-0277c785a3840d5552a683eb740b46cb.png";